module.exports = __webpack_public_path__ + "8ce459ae1b8fea2453901a3618066486.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-top.png
// module id = 2293
// module chunks = 0